//const moment = require('moment');
//require('moment/locale/kz');
//require('moment/locale/ru');
//require('moment/locale/en');
//moment.locale('kz');
// moment.locale('en-US');
// moment.locale('ru');

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import 'dayjs/locale/en'
import 'dayjs/locale/kk'
import localizedFormat from 'dayjs/plugin/localizedFormat';
import updateLocale from 'dayjs/plugin/updateLocale'
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(localizedFormat);
dayjs.extend(updateLocale);
dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.locale('ru')
dayjs.locale('en')
dayjs.locale('kk')

dayjs.updateLocale('ru', {
    months: [
        'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
        'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
    ],
    longDateFormat: {
        L: "D MMMM YYYY года"
    }
});

export default {
    install(Vue) {
        Vue.prototype.$dayjs = dayjs;
    }
};